import { getEnvironment } from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;
const MAX_TAB_AGE_PROD_IN_MS = 7 * ONE_DAY_IN_MS;
// Shorter threshold in non-prod so the behaviour can be soaked without waiting a week.
const MAX_TAB_AGE_NON_PROD_IN_MS = ONE_DAY_IN_MS;

const getMaxTabAge = (): number => {
	const env = getEnvironment();
	const isNonProd = env === 'staging' || env === 'dev' || env === 'local';
	return isNonProd ? MAX_TAB_AGE_NON_PROD_IN_MS : MAX_TAB_AGE_PROD_IN_MS;
};

// `performance.now()` is the time elapsed since the document started loading (measured relative to
// timeOrigin): it starts at the initial navigation, is stable across SPA navigations, and resets on
// the forced reload - so it needs no bookkeeping, and being monotonic it is immune to wall-clock
// changes. Fail open if performance is unavailable so an unreliable signal can't trigger a reload.
export const isTabTooOld = (): boolean => {
	const tabAge = globalThis.performance?.now();
	if (typeof tabAge !== 'number') {
		return false;
	}
	return tabAge > getMaxTabAge();
};
